export default __webpack_public_path__ + "static/media/mjit_white.b584ea25.png";